import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CallDetailsModalComponent from './CallDetailsModalComponent';
import RemoteDoormanAgentsLogComponent from './RemoteDoormanAgentsLogComponent';

import { showRenderPropsModal } from '../Modal/actions';
import {
  getCallCenterAgentsList,
  getCallCenterAgentsLog,
  getRemoteDoormanCallById,
} from './actions';

import { getTodayCount } from '../../utils';

import * as commonSelectors from '../Shared/selectors';
import * as selectors from './selectors';

const listKey = 'RemoteDoormanAgentsLog';

const RemoteDoormanAgentsLogContainer = (props) => {
  const {
    onGetRemoteDoormanAgentsLog,
    onGetRemoteDoormanCallById,
    openCallDetailsModal,
    listParams,
  } = props;

  const getModalProps = (callId) => ({
    title: 'call details',
    maxWidth: 'sm',
    render: (props) => (
      <CallDetailsModalComponent
        {...props}
        listParams={listParams}
        onGetRemoteDoormanCallById={onGetRemoteDoormanCallById}
        callId={callId}
      />
    ),
  });

  const onOpenCallDetailsModal = (callId) => {
    const modalProps = getModalProps(callId);
    openCallDetailsModal(modalProps);
  };

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetRemoteDoormanAgentsLog(queryParams);
  };

  return (
    <RemoteDoormanAgentsLogComponent
      {...props}
      onOpenCallDetailsModal={onOpenCallDetailsModal}
      onExport={onExport}
    />
  );
};

RemoteDoormanAgentsLogContainer.propTypes = {
  onGetRemoteDoormanAgentsLog: PropTypes.func.isRequired,
  onGetRemoteDoormanCallById: PropTypes.func.isRequired,
  openCallDetailsModal: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const listParams = commonSelectors.getListParams(state, listKey);
  const items = selectors.getCallCenterAgentsLog(state);
  const agentOptions = selectors.getCallCenterAgentOptions(state);
  return {
    listKey,
    listParams,
    items,
    agentOptions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (params) => {
    getCallCenterAgentsList(dispatch, { ...params, disable_pagination: true });
  },
  getItems: (queryParams) => {
    getCallCenterAgentsLog(dispatch, queryParams);
    getTodayCount(getCallCenterAgentsLog, dispatch, queryParams);
  },
  onGetRemoteDoormanAgentsLog: (queryParams) =>
    getCallCenterAgentsLog(dispatch, queryParams, true),
  onGetRemoteDoormanCallById: (callId) =>
    getRemoteDoormanCallById(dispatch, callId),
  openCallDetailsModal: (modalProps) =>
    showRenderPropsModal(dispatch, modalProps),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoteDoormanAgentsLogContainer);
